<template>
  <div>
    <div class="nav-header" :class="{'nav-shadow':ifShowBotline}">
      <div v-if="!noBackIcon" class="left" @click="backClick">
        <img class="back-icon" src="https://restaskimg.civaonline.cn/imagesH5/other/head-back.png" alt="">
      </div>
      <div v-if="noBackIcon" slot="left" class="left">
        <img class="logo" src="https://restaskimg.civaonline.cn/imagesH5/home/logo.png" alt="civa">
      </div>
      <div v-if="!noBackIcon" class="title">
        {{ headTitle }}
      </div>
      <div v-if="showTryOut" class="ontrial" @click="showOnTrial = 1">免费试用</div>
      <div v-if="showMenu" class="right">
        <img class="menu-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/menu.png" alt="" @click="popupVisible=!popupVisible">
      </div>
    </div>
    <!--头部站位-->
    <div class="navbar-hidden" />
    <van-popup v-model="popupVisible" class="menu-popup" overlay-class="menu-box">
      <ul class="h-nav clearfix">
        <li class="h-nav-li" @click="goPage('/')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/home.png" alt="">
          <span class="nav-title">首页</span>
        </li>
        <li class="h-nav-li" @click="goPage('/textbook')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/textbook.png" alt="">
          <span class="nav-title">教材</span>
        </li>
        <li class="h-nav-li" @click="goPage('/product')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/product.png" alt="">
          <span class="nav-title">产品</span>
        </li>
        <li class="h-nav-li" @click="goPage('/service')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/service-menu.png" alt="">
          <span class="nav-title">服务</span>
        </li>
        <li class="h-nav-li" @click="goPage('/joinCooperation')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/cooperation-menu.png" alt="">
          <span class="nav-title">合作</span>
        </li>
        <li class="h-nav-li" @click="goPage('/case')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/case.png" alt="">
          <span class="nav-title">案例</span>
        </li>
        <li class="h-nav-li last-li" @click="goPage('/recruit')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/recruit.png" alt="">
          <span class="nav-title">招聘</span>
        </li>
        <li class="h-nav-li last-li" @click="goPage('/news')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/news.png" alt="">
          <span class="nav-title">新闻</span>
        </li>
        <li class="h-nav-li last-li" @click="goPage('/download')">
          <img class="nav-icon" src="https://restaskimg.civaonline.cn/imagesH5/home/download.png" alt="">
          <span class="nav-title">下载</span>
        </li>
      </ul>
      <div class="popup-close" @click="popupVisible=false">
        <img src="https://restaskimg.civaonline.cn/imagesH5/home/close-icon.png" alt="">
      </div>
    </van-popup>


    <div v-if="showExtension" class="ontrial1" @click.stop>
      <img class="ot-robot" src="@/assets/images/ontrial/robot.png" alt="">
      <img class="ot-close" @click="onHideOntrial" src="@/assets/images/ontrial/close.png" alt="">
      <div class="ontrial1-slogan">让孩子放心就读10年的英语学校</div>
      <div class="ontrial1-opear">
        <div class="ot1-opear-btn transparent" @click="onOnTrial">免费试用</div>
        <a href="tel:400-9699-200"><div class="ot1-opear-btn">电话咨询</div></a>
      </div>
    </div>
    <van-popup v-if="showOnTrial == 1" :value="true" class="menu-popup" :close-on-click-overlay="false" position="bottom">
      <div class="ontrial-main">
        <div class="ontrial-head">
          <img class="ontrial-head-bg" src="@/assets/images/ontrial/title-bg.png" />
          <span class="ontrial-head-title">免费试用</span>
          <img @click="showOnTrial = 0" class="ontrial-head-close" src="@/assets/images/ontrial/close.png" />
        </div>
        <div class="ontrial-content">
          <img class="ontrial-contact" src="@/assets/images/ontrial/phonenum.png" alt="">
          <div class="ontrial-form">
            <div class="ontrial-form-item">
              <div class="ontrial-form-label"><img class="ontrial-form-label-icon" src="@/assets/images/ontrial/ep.png" alt=""></div>
              <div class="ontrial-form-content">
                <field v-model="orTrialData.organization" type="text" maxLength="30" placeholder="请输入学校名称" class="ontrial-form-input" />
              </div>
            </div>
            <div class="ontrial-form-item">
              <div class="ontrial-form-label"><img class="ontrial-form-label-icon" src="@/assets/images/ontrial/user.png" alt=""></div>
              <div class="ontrial-form-content">
                <field v-model="orTrialData.name" type="text" maxLength="10" placeholder="请输入您的名字" class="ontrial-form-input" />
              </div>
            </div>
            <div class="ontrial-form-item">
              <div class="ontrial-form-label"><img class="ontrial-form-label-icon" src="@/assets/images/ontrial/phone.png" alt=""></div>
              <div class="ontrial-form-content">
                <field v-model="orTrialData.mobile" type="tel" maxLength="11" placeholder="请输入您的手机号码" class="ontrial-form-input" />
              </div>
            </div>
          </div>
          <div v-if="canSubmit"  class="ortrial-form-submit" @click="onTrialSubmit">提交</div>
          <div v-else class="ortrial-form-submit disabled">提交</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Field } from 'vant';
import { userSign } from '@/api/signup'
import { validatMobile } from '@/utils/tools'
export default {
  props: {
    noBackIcon: {
      type: Boolean,
      default: false,
    },
    ifShowBotline: {
      type: Boolean,
      default: false,
    },
    pageTitle: {
      type: String,
      default: null,
    },
    showExtension: {
      type: Boolean,
      default: false,
    },
    showTryOut: {
      type: Boolean,
      default: true,
    },
    showMenu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headTitle: this.$route.meta.title,
      popupVisible: false,
      title: '',
      showOnTrial: 0,

      orTrialData: {
        name: '',
        mobile: '',
        verificationCode: '123456',
        organization: '',
        province: '默认值',
        city: '默认值',
        district: '默认值',
        scale: '默认值',
        referrer: '',
        referrerMobile: '',
      },
    }
  },
  components: { Field },
  watch: {
    pageTitle(val) {
      this.title = val || this.$route.meta.title;
      document.title = this.title;
    },
  },
  computed: {
    canSubmit() {
      const { name, mobile, organization } = this.orTrialData
      if (name && validatMobile(mobile) && organization) {
        return true
      }
      return false;
    },
  },
  mounted() {
    // this.headTitle = this.$route.meta.title;
  },
  methods: {
    backClick() {
      this.$router.go(-1); // 返回上一层
    },
    goPage(path) {
      if (this.$route.path === path) {
        this.popupVisible = false;
      } else {
        this.$router.push(path);
      }
    },

    onOnTrial() {
      this.showOnTrial = 1
      this.$emit('changeExtension', false)
    },
    onHideOntrial() {
      this.showOnTrial = 0
      this.$emit('changeExtension', false)
    },

    onTrialSubmit() {
      const ontrialToast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '申请中',
      })
      userSign(this.orTrialData).then(res => {
        this.$toast.clear(ontrialToast)
        this.showOnTrial = 0
        if (res.returnNo === '0060') {
          this.$toast.success({ message: '申请成功', duration: 5 * 1000 });
        } else {
          this.$toast({
            message: res.returnInfo || 'error',
            duration: 3 * 1000,
          })
        }
      })
    }
  },
}
</script>
<style scoped lang="less">
	.navbar-hidden{
		height: 88px;
		width: 100%;
	}
	.nav-shadow{
		box-shadow: 0 2px 0 0 #E4E4E4;
	}
	.nav-header{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		padding: 0 32px;
		height: 88px;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #ffffff;
		.left{
			width: 110px;
			.logo{
				width: 100%;
			}
			.back-icon{
				width: 20px;
			}
		}
		.title{
			flex: 1;
			font-size: 36px;
			color: #293340;
			text-align: center;
		}
		.right{
			width: 110px;
			line-height: 88px;
			.menu-icon{
				width: 36px;
				float: right;
			}
		}
	}
	.popup-close{
		position: absolute;
		bottom: -200px;
		left: 50%;
		margin-left: -14px;
		display: inline-block;
		img{
			width: 27px;
		}
	}
	.h-nav{
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		background-color: transparent;
		.h-nav-li{
			width: 33.33%;
			float: left;
			padding: 0 60px;
			box-sizing: border-box;
			text-align: center;
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-bottom: 65px;
			.nav-icon{
				max-width: inherit;
				width: 120px;
				height: 120px;
			}
			.nav-title{
				margin-top: 3px;
			}
		}
		.last-li{
			margin-bottom: 0;
		}
  }
  .ontrial{
    position: absolute;
    right: 100px;
    top: 16px;
    width:140px;
    height:56px;
    line-height: 56px;
    background:rgba(255,117,0,1);
    border-radius:6px;
    color: #fff;
    font-size: 24px;
    text-align: center;
  }


  .ontrial1{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100vw;
    height: 560px;
    background:rgba(0,0,0,0.6);
    .ot-robot{
      width: 174px;
      display: block;
      margin: 40px auto;
    }
    .ot-close{
      width: 24px;
      position: absolute;
      top: 60px;
      right: 30px;
    }
    .ontrial1-slogan{
      font-size:36px;
      line-height: 39px;
      font-family:CTZhongYuanSJ;
      margin: 0 auto;
      padding: 10px 0 60px;
      letter-spacing:5px;
      text-shadow:0px 3px 9px rgba(0,0,0,0.5);
      color: #fff;
      text-align: center;
    }

    .ontrial1-opear{
      display: flex;
      justify-content: center;
    }
    .ot1-opear-btn{
      width:240px;
      height:78px;
      background:rgba(255,255,255,1);
      border-radius:10px;
      border:2px solid rgba(255,255,255,1);
      font-size: 30px;
      font-weight: bold;
      line-height: 78px;
      text-align: center;
      color: #FF7500;
      &.transparent{
        background: transparent;
        color: #fff;
        margin-right: 60px;
      }
    }
  }


	.ontrial-main{
		width: 100%;
		background:rgba(255,255,255,1);
    border-radius: 10px 10px 0 0;
    
    .ontrial-head{
      width: 100%;
      height: 120px;
      .ontrial-head-bg{
        position: relative;
        width: 100%;
        top: 0;
      }
      .ontrial-head-title{
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        text-align: center;
        font-size: 40px;
        line-height: 120px;
        color: #fff;
        font-weight: bold;
        font-family:MicrosoftYaHei-Bold,MicrosoftYaHei;
      }
      .ontrial-head-close{
        position: absolute;
        width: 24px;
        top: 30px;
        right: 30px;
      }
    }

    .ontrial-contact{
      display: block;
      width: 326px;
      margin: 40px auto;
    }

    .ontrial-form{
      margin: 0 40px 40px;
    }
    
    .ontrial-form-item{
      height: 120px;
      border-radius: 10px;
      border: 2px solid #999;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-bottom: 40px;
    }

    .ontrial-form-label-icon{
      display: block;
      width: 30px;
      height: 30px;
      margin: 0 20px 0 20px;
    }
    .ontrial-form-content{
      flex: 1;
    }
    .ontrial-form-input{
      width: 100%;
      height: 118px;
      line-height: 118px;
      border: 0;
      outline: none;
      font-size: 28px;
      color: #333;
      padding: 0;
    }

    .ortrial-form-submit{
      height:88px;
      line-height: 88px;
      text-align: center;
      background:rgba(255,117,0,1);
      font-size: 32px;
      letter-spacing: 3px;
      color: #fff;
      font-weight: bold;
      font-family:MicrosoftYaHei-Bold,MicrosoftYaHei;
      &.disabled{
        background: #aaa;
      }
    }
	}
</style>
